<template>
  <div class="popup_wrap vgm_pop vgm_area" style="width:950px; max-height:600px;">
    <button class="layer_close" @click="$emit('close')">close</button>
    <div class="popup_cont">
      <h1 class="page_title">{{ $t('msg.CSBL200.328') }}</h1> <!-- Master-House Container 일치 여부 확인 -->
      <div class="content_box">
        <table class="tbl_col">
          <colgroup>
            <col width="31%">
            <col width="23%">
            <col width="23%">
            <col width="23%">
          </colgroup>
          <thead>
            <tr>
              <th>Master Container No.</th> <!-- Master Container No. -->
              <th>Weight (kgs)</th> <!-- Weight (kgs) -->
              <th>Measure</th> <!-- Measure -->
              <th>Package</th> <!-- Package -->
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>
                <select
                  v-model="masterCntrNo"
                  class="wid200"
                  @change="changeMasterCntrNo($event)"
                >
                  <option v-for="(vo, idx) in masterCntrList" :key="'cntrNo_' + idx" :value="vo.cntrNo">{{ vo.cntrNm }}</option>
                </select>
              </td>
              <td>
                <p>{{ masterWgt }}</p>
              </td>
              <td>
                <p>{{ masterCbm}}</p>
              </td>
              <td>
                <p>{{ masterPkg}}</p>
              </td>
            </tr>
          </tbody>
        </table>
      </div><!-- content_box // -->
      <div class="content_box">
        <table class="tbl_col">
          <colgroup>
            <col width="31%">
            <col width="23%">
            <col width="23%">
            <col width="23%">
          </colgroup>
          <tbody>
            <tr>
              <th rowspan="2">House B/L Total</th> <!-- House B/L Total -->
              <th>Weight (kgs)</th> <!-- Weight (kgs) -->
              <th>Measure</th> <!-- Measure -->
              <th>Package</th> <!-- Package -->
            </tr>
            <tr>
              <td class="border_left">{{ houseTotWgt }}</td>
              <td>{{ houseTotCbm }}</td>
              <td>{{ houseTotPkg }}</td>
            </tr>
          </tbody>
        </table>

        <table class="tbl_col mt20">
          <colgroup>
            <col width="10%">
            <col width="25%">
            <col width="25%">
            <col width="25%">
            <col width="25%">
          </colgroup>
          <thead>
            <tr>
              <th>No.</th> <!-- No. -->
              <th>House B/L No.</th> <!-- House B/L No. -->
              <th>Weight (kgs)</th> <!-- Weight (kgs) -->
              <th>Measure</th> <!-- Measure -->
              <th>Package</th> <!-- Package -->
            </tr>
          </thead>
          <tbody>
            <tr v-for="(selectHouseCntrVo, index) in selectHouseCntrList" :key="index">
              <td>
                <p>{{ index + 1 }}</p>
              </td>
              <td>
                <p>{{ selectHouseCntrVo.fwdrBlNo }}</p>
              </td>
              <td>
                <p>{{ selectHouseCntrVo.wt }}</p>
              </td>
              <td>
                <p>{{ selectHouseCntrVo.grsCbm }}</p>
              </td>
              <td>
                <p>{{ selectHouseCntrVo.pkgQty }}</p>
              </td>
            </tr>
          </tbody>
        </table>
      </div><!-- content_box // -->
      <div class="mt10 text_center">
        <a class="button gray lg" href="#" @click.prevent="$emit('close')">{{ $t('msg.ONEX010P100.036') }}</a> <!-- 닫기 -->
      </div>
    </div><!-- popup_cont -->
  </div>
</template>

<script>
import { rootComputed } from '@/store/helpers'
import EDatePicker from '@/components/common/EDatePicker'
import EInputNumber from '@/components/common/EInputNumber'

export default ({
  name: 'VgmPop',
  components: {
    EDatePicker,
    EInputNumber
  },
  props: {
    parentInfo: {
      type: Object,
      default: function () {
        return {
          containerList: [],
          houseBlList: []
        }
      }
    }
  },
  data () {
    return {
      masterCntrNo: '',
      masterWgt: '',
      masterCbm: '',
      masterPkg: '',
      houseTotWgt: '',
      houseTotCbm: '',
      houseTotPkg: '',
      masterCntrList: [],
      houseCntrList: [],
      selectHouseCntrList: []
    }
  },
  computed: {
    ...rootComputed
  },
  async created () {
    for (let c of this.parentInfo.houseBlList) {
      if (c.houseBlContainerList.length > 0) {
        for (let d of c.houseBlContainerList) {
          d.fwdrBlNo = c.fwdrBlNo
          this.houseCntrList.push(d)
        }
      }
    }

    // this.masterCntrList = this.parentInfo.containerList
    for (let a of this.parentInfo.containerList) {
      let totWt = 0
      let totCbm = 0
      let totPkg = 0
      for (let b of this.houseCntrList) {
        if (a.cntrNo === b.cntrNo) {
          totWt = Number(totWt) + Number(b.wt)
          totCbm = Number(totCbm) + Number(b.grsCbm)
          totPkg = Number(totPkg) + Number(b.pkgQty)
        }
      }
      totWt = Number(totWt.toFixed(3))
      totCbm = Number(totCbm.toFixed(4))
      if (Number(a.wt) === Number(totWt) &&
          Number(a.meaCbm) === Number(totCbm) &&
          Number(a.pkgQty) === Number(totPkg)) {
        a.cntrNm = a.cntrNo + this.$t('msg.CSBL200.329')
      } else {
        a.cntrNm = a.cntrNo + this.$t('msg.CSBL200.330')
      }

      this.masterCntrList.push(a)
    }

    this.masterCntrNo = this.masterCntrList[0].cntrNo
    this.changeMasterCntrNo()
  },
  methods: {
    changeMasterCntrNo () {
      this.masterWgt = ''
      this.masterCbm = ''
      this.masterPkg = ''
      this.houseTotWgt = ''
      this.houseTotCbm = ''
      this.houseTotPkg = ''
      this.selectHouseCntrList = []

      for (let m of this.masterCntrList) {
        if (this.masterCntrNo === m.cntrNo) {
          this.masterWgt = m.wt
          this.masterCbm = m.meaCbm
          this.masterPkg = m.pkgQty
        }
      }
      for (let h of this.houseCntrList) {
        if (this.masterCntrNo === h.cntrNo) {
          this.houseTotWgt = Number(this.houseTotWgt) + Number(h.wt)
          this.houseTotCbm = Number(this.houseTotCbm) + Number(h.grsCbm)
          this.houseTotPkg = Number(this.houseTotPkg) + Number(h.pkgQty)
          this.selectHouseCntrList.push(h)
        }
      }
      this.houseTotWgt = Number(this.houseTotWgt.toFixed(3))
      this.houseTotCbm = Number(this.houseTotCbm.toFixed(4))
    }
  }
})
</script>
<style scoped>
.sp {width: 3px;display: inline-block;}
#vocForm .grid.service_rdo li{margin-left: 13px;margin-right: 0;}
#vocForm .grid.service_rdo li:first-child{margin-left: 0;}
.input_calendar.mid, .input_calendar.mid input{width: 100px}
.div-file {
  display: inline-block;
}
.div-file > button {
  display: inline-block;
}
</style>
